import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";

import { AllianzBanner } from "./AllianzBanner";

type Props = ThemeSlotPropsMap["pageHeading"];

const IMAGE_MAP: Record<string, string> = {
  advice:
    "https://www.allianz.nl/particulier/hypotheken/afsluiten/aanvragen/_jcr_content/root/parsys/wrapper_copy_copy_co_524970717/wrapper/multi_column_grid_co_522658948/grid-0-par/image.img.82.1280.png/1738932320049/man-and-woman-in-front-of-laptop.png",
  documentsOutgoing:
    "https://www.allianz.nl/particulier/producten/autoverzekering/_jcr_content/root/parsys/wrapper_1403549667_c_1051505428/wrapper/wrapper_1348529754/wrapper/wrapper/wrapper/image_copy.img.82.3360.png/1742465616391/001.png",
  documentsIncoming:
    "https://www.allianz.nl/particulier/producten/autoverzekering/_jcr_content/root/parsys/wrapper_1403549667_c_1051505428/wrapper/wrapper_1348529754/wrapper/wrapper/wrapper/image_copy.img.82.3360.png/1742465616391/001.png",
  interestRates:
    "https://www.allianz.nl/particulier/hypotheken/afsluiten/rente/_jcr_content/root/parsys/wrapper_copy_copy_co_1301354847/wrapper/multi_column_grid_co/grid-1-par/image.img.82.1280.png/1739354320074/man-bestudeert-grafieken-en-diagrammen-op-een-schoolbord.png",
  maximumMortgage:
    "https://www.allianz.nl/particulier/hypotheken/afsluiten/aanvragen/_jcr_content/root/parsys/wrapper_copy_copy_co_524970717/wrapper/multi_column_grid_co/grid-1-par/image.img.82.1280.png/1738932220063/man-maakt-een-berekening-op-een-telraam.png",
  orientation:
    "https://www.allianz.nl/particulier/hypotheken/afsluiten/aanvragen/_jcr_content/root/parsys/wrapper_copy_copy_co_524970717/wrapper/multi_column_grid_co_1008834081/grid-1-par/image.img.82.1280.png/1738932331226/man-and-woman-with-tablet.png",
};

export const AllianzPageHeading: FC<Props> = ({ scope }) => {
  const { t } = useTranslation();

  return (
    <AllianzBanner
      title={t(`${scope}Heading.title`)}
      description={t(`${scope}Heading.description`)}
      imageSrc={IMAGE_MAP[scope] ?? ""}
    />
  );
};
